
// The app's inline loading state: the RunDiffusion mark loader in a box of
// the given size. The mark takes half the box's width, the footprint the
// Lottie animation it replaced had, so every caller's layout stays as it was.
import Vue from 'vue';
import MarkLoader from '@/components/base/MarkLoader.vue';

export default Vue.extend({
	name: 'LoadingSVG',
	props: {
		height: {
			type: [Number, String],
			default: 200,
		},
		width: {
			type: [Number, String],
			default: 200,
		},
	},
	computed: {
		boxWidth (): number {
			return Number(this.width) || 200;
		},
		boxHeight (): number {
			return Number(this.height) || 200;
		},
		markSize (): number {
			return Math.round(Math.min(this.boxWidth, this.boxHeight) * 0.5);
		},
	},
	components: {
		MarkLoader,
	},
});
